import projectGQLClient from "@restaurant-store-gql-client";
import { type ResultOf, type VariablesOf } from "gql.tada";
import { type DocumentNode } from "graphql";

type GQLClient<QueryType extends DocumentNode> = (
  config: {
    query: QueryType;
    variables: VariablesOf<QueryType>;
    abortSignal?: AbortSignal;
  } & RequestInit,
) => Promise<ResultOf<QueryType>>;

type ValidateGQLClient<T> = T extends GQLClient<DocumentNode> ? T : never;

const client: ValidateGQLClient<typeof projectGQLClient> = projectGQLClient;

export default client;
